export default "__VITE_ASSET__1c533380__"